<p-dialog
  [contentStyle]="{ overflow: 'auto' }"
  [styleClass]="'sm:col-12 md:col-6 lg:col-5 xl:col-4'"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  (onHide)="close($event)"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Send_DocEmail' | translate}}
    </span>
  </ng-template>

  <div class="col-12 align">
    <span>{{ tools.getSelectdedCount(selectedDocs.length) }}</span>
  </div>

  <div class="col-12">
    <form [formGroup]="mailForm" class="grid form-group">
      <div class="col-12">
        <span class="p-float-label size_cent">
          <input formControlName="mailTo" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'MailTo' | translate}}</label>
        </span>
      </div>
      <div class="col-12">
        <span class="p-float-label size_cent">
          <input formControlName="mailCc" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'MailCc' | translate}}</label>
        </span>
      </div>
      <div class="col-12">
        <span class="p-float-label size_cent">
          <input formControlName="mailCci" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'MailCci' | translate}}</label>
        </span>
      </div>
      <div class="col-12">
        <span class="p-float-label size_cent">
          <input formControlName="mailSubject" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'MailSubj' | translate}}</label>
        </span>
      </div>
      <div class="col-12 ui-float-label">
        <div>{{'Message' | translate}}</div>
        <textarea formControlName="mailMsg" rows="5" cols="45" pInputTextarea></textarea>
      </div>
      @if (addAtf === true) {
        <div class="col-12 left">
          <p-checkbox
            formControlName="mailAddAtf"
            binary="true"
            inputId="MailAddAtf"
          ></p-checkbox>
          <label for="MailAddAtf" class="ml-2">{{'MailAddAtf' | translate}}</label>
        </div>
      }
      <div class="col-12 left">
        <p-checkbox
          formControlName="mailZip"
          binary="true"
          inputId="MailZip"
        ></p-checkbox>
        <label for="MailZip" class="ml-2">{{'MailZip' | translate}}</label>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <button class="margin" pButton type="button" (click)="onClickSendMail()" label="{{'Send' | translate}}"></button>
  </ng-template>
</p-dialog>

